<ng-template #updateModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'New Mipro REGO version available' | translate}}</h4>
  </div>
  <div class="modal-body">
    <div class="list-group list-group-flush">
      <div class="list-group-item flex-column align-items-start" *ngIf="availableVersion.generalDescription">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{'App update description' | translate}}</h5>
        </div>
        <p class="mb-1 line-breaker">
          {{availableVersion.generalDescription}}
        </p>
      </div>
      <ng-container *qmAuth="'vivo'">
        <div class="list-group-item flex-column align-items-start" *ngIf="availableVersion.vivoDescription">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{'VIVO updates description' | translate}}</h5>
          </div>
          <p class="mb-1 line-breaker">
            {{availableVersion.vivoDescription}}
          </p>
        </div>
      </ng-container>
      <div class="list-group-item flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{'App version number' | translate}}</h5>
        </div>
        <p class="mb-1">
          {{availableVersion.versionNumber}}
        </p>
      </div>
      <div class="list-group-item flex-column align-items-start" *ngIf="availableVersion.tenantSpecificDescription">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{'Tenant specific updates' | translate}}</h5>
        </div>
        <p class="mb-1 line-breaker">
          {{availableVersion.tenantSpecificDescription}}
        </p>
      </div>
      <div class="list-group-item flex-column align-items-start" *ngIf="availableVersion.resetCache">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{'Update requires local cache reset' | translate}}</h5>
        </div>
        <p class="mb-1">
          {{'After the update, your info windows, map layers and all filters will reset to their default values and you might be required to login to application.' | translate}}
        </p>
      </div>
      <div class="list-group-item flex-column align-items-start" *ngIf="availableVersion.forcedUpdate">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{'Time until mandatory update is applied automatically' | translate}}</h5>
        </div>
        <p class="mb-1">
          <ngb-progressbar [type]="counter < 60 ? 'success' : (counter > 90 ? 'danger' : 'warning')"
                           [value]="counter / 120 * 100" [striped]="true" [animated]="true"><i>{{counterText}}</i>
          </ngb-progressbar>
        </p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" ngbAutofocus
            (click)="modal.close('Reload')">{{'Install update and reload' | translate}}</button>
  </div>
</ng-template>
